import { all } from 'redux-saga/effects';
import { authStore } from 'src/auth';
import { solutionsStore } from 'src/pages/Solutions';
import { companiesStore } from 'src/pages/Companies';
import { otpStore } from 'src/pages/Otp';
import { usersStore } from 'src/pages/Users';
import { sitesStore } from 'src/pages/Sites';
import { monitoringStore } from 'src/pages/Monitoring';
import { alertsStore } from 'src/pages/Alerts';
import { infraMapStore } from 'src/pages/InfraMap';
import { platformVersionsStore } from 'src/pages/Settings/PlatformVersions';

export default function* rootSaga() {
  yield all([
    authStore.saga(),
    solutionsStore.saga(),
    companiesStore.saga(),
    otpStore.saga(),
    usersStore.saga(),
    sitesStore.saga(),
    monitoringStore.saga(),
    alertsStore.saga(),
    infraMapStore.saga(),
    platformVersionsStore.saga(),
  ]);
}
